import styled from 'styled-components';
import Input from 'components/Input';
import UniversalForm from 'components/UniversalForm';
import { DIVIDER } from '../../../../constants';

export const StyledUniversalForm = styled(UniversalForm)`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`;

export const StyledInput = styled(Input)`
    max-width: 31.25rem;
    
    label {
        margin-left: 0;
        font-size: 0.8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    input {
        border: 1px solid ${DIVIDER};
        border-radius: 0.375rem;

        ::placeholder {
            font-weight: 300 !important;
        }
    }

    div[id^="error-message"] {
        align-self: flex-start;
    }
`;
